<ag-grid-angular
    class="ag-theme-material"
    style="height: 300px; width: 100%;"
    [rowData]="patientHistoryList"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
    (columnResized)="onColumnResized()"
    (gridSizeChanged)="onGridSizeChanged($event)">
</ag-grid-angular>

